import AltInstance from '../Globals/Scripts/AltInstance';
import ActionInProgressActions from '../Actions/ActionInProgressActions'

class ActionInProgressStore {
    constructor() {
        this.bindActions(ActionInProgressActions);
        this.actionsInProgress = [];
    }

    onActionStarted(actionIdentifier) {
        this.actionsInProgress.push(actionIdentifier);
    }

    onActionCompleted(actionIdentifer) {
        this.actionsInProgress = this.actionsInProgress.filter((value) => { value != actionIdentifer });
    }

    static anyActionInProgress() {
        return this.getState().actionsInProgress.length !==0;
    }
}

export default AltInstance.createStore(ActionInProgressStore, 'ActionInProgressStore');
